// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccordionSection {
  width: 100%;
  color: black;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-bottom: 20px;
  margin-bottom: 40px;
  /* border-bottom: 4px double #89CFF0; */
}

.AccordionSection-content {
  width: 80%;
}

.AccordionSection-title {
  font-family: "Quicksand", serif;
  font-weight: 700;
  font-size: 40px;
  text-align: left;
  padding-top: 20px;
  padding-bottom: 30px;
  @media screen and (max-width: 500px) {
    font-size: 28px;
  }
}

.AccordionSection-faq {
  text-align: left;
}

.btn-primary {
  background-color: white;
  color: #7faedc;
  border: none;
  box-shadow: none;
  font-weight: bold;
  height: 100%;
  padding: 0;
  margin-left: 5px;
  margin-top: -2.6px;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary:checked {
  background-color: white;
  text-decoration: underline;
  color: #7faedc;
  border: none;
  box-shadow: none;
  font-weight: bold;
  height: 100%;
  padding: 0;
  margin-left: 5px;
  margin-top: -2.6px;
}

.tooltip-inner {
  background-color: #7faedc;
  border: 1px solid #7faedc;
  color: white;
}

.bs-tooltip-bottom .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #7faedc;
}
`, "",{"version":3,"sources":["webpack://./src/AccordionSection.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;EAIE,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,4BAA4B;AAC9B","sourcesContent":[".AccordionSection {\n  width: 100%;\n  color: black;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  padding-bottom: 20px;\n  margin-bottom: 40px;\n  /* border-bottom: 4px double #89CFF0; */\n}\n\n.AccordionSection-content {\n  width: 80%;\n}\n\n.AccordionSection-title {\n  font-family: \"Quicksand\", serif;\n  font-weight: 700;\n  font-size: 40px;\n  text-align: left;\n  padding-top: 20px;\n  padding-bottom: 30px;\n  @media screen and (max-width: 500px) {\n    font-size: 28px;\n  }\n}\n\n.AccordionSection-faq {\n  text-align: left;\n}\n\n.btn-primary {\n  background-color: white;\n  color: #7faedc;\n  border: none;\n  box-shadow: none;\n  font-weight: bold;\n  height: 100%;\n  padding: 0;\n  margin-left: 5px;\n  margin-top: -2.6px;\n}\n\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary:active,\n.btn-primary:checked {\n  background-color: white;\n  text-decoration: underline;\n  color: #7faedc;\n  border: none;\n  box-shadow: none;\n  font-weight: bold;\n  height: 100%;\n  padding: 0;\n  margin-left: 5px;\n  margin-top: -2.6px;\n}\n\n.tooltip-inner {\n  background-color: #7faedc;\n  border: 1px solid #7faedc;\n  color: white;\n}\n\n.bs-tooltip-bottom .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 0.4rem 0.4rem;\n  border-bottom-color: #7faedc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
